var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "main-content",
          attrs: {
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            "destroy-on-close": true,
            "before-close": _vm.close,
            title: _vm.$t("SeaExport.PickingList"),
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "warehousing-detail" },
            [
              _c(
                "el-form",
                {
                  ref: "pickingOrderForm",
                  attrs: {
                    model: _vm.pickingOrder,
                    "label-width": "100px",
                    "label-position": "right",
                    "show-message": false
                  }
                },
                [
                  _c("el-collapse", [
                    _c("div", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-row",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row"
                          }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                "label-width": "100px",
                                "label-position": "right",
                                disabled: true
                              }
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.Warehouse")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.warehouseName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "warehouseName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.warehouseName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.FreightStation"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder
                                                  .deliveryStation,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "deliveryStation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.deliveryStation"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.WarehouseEntrySerialNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.warehouseNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "warehouseNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.warehouseNo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.MasterBillNo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.pickingOrder.mbl,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "mbl",
                                                  $$v
                                                )
                                              },
                                              expression: "pickingOrder.mbl"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.JobNo")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.pickingOrder.jobNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "jobNo",
                                                  $$v
                                                )
                                              },
                                              expression: "pickingOrder.jobNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.PickingStatus"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              model: {
                                                value:
                                                  _vm.pickingOrder
                                                    .pickingStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pickingOrder,
                                                    "pickingStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pickingOrder.pickingStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-option",
                                                {
                                                  attrs: {
                                                    value: 0,
                                                    label: _vm.$t(
                                                      "SeaExport.No"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("SeaExport.No")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-option",
                                                {
                                                  attrs: {
                                                    value: 1,
                                                    label: _vm.$t(
                                                      "SeaExport.Yes"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("SeaExport.Yes")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.CargoVehicle"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder
                                                  .deliveryVehicle,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "deliveryVehicle",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.deliveryVehicle"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.Driver")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.pickingOrder.driver,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "driver",
                                                  $$v
                                                )
                                              },
                                              expression: "pickingOrder.driver"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.Tel")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.pickingOrder.tel,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "tel",
                                                  $$v
                                                )
                                              },
                                              expression: "pickingOrder.tel"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.PickingOrderNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.pickingOrderNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "pickingOrderNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.pickingOrderNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("SeaExport.Consignee")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value: _vm.pickingOrder.consignee,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "consignee",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.consignee"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.DeliveryTime3"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.deliveryTime,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "deliveryTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.deliveryTime"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.OutboundStatus"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              model: {
                                                value:
                                                  _vm.pickingOrder
                                                    .outboundStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pickingOrder,
                                                    "outboundStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pickingOrder.outboundStatus"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-option",
                                                {
                                                  attrs: {
                                                    value: 0,
                                                    label: _vm.$t(
                                                      "SeaExport.No"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("SeaExport.No")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-option",
                                                {
                                                  attrs: {
                                                    value: 1,
                                                    label: _vm.$t(
                                                      "SeaExport.Yes"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("SeaExport.Yes")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.OutboundUser"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.outboundUser,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "outboundUser",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.outboundUser"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Warehouse.DeliveryDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.outboundTime,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "outboundTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.outboundTime"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.AssemblyPlanNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.pickingOrder.assemlyPlanNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "assemlyPlanNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.assemlyPlanNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "SeaExport.OutboundRemarks"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value:
                                                _vm.pickingOrder
                                                  .outboundRemarks,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pickingOrder,
                                                  "outboundRemarks",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pickingOrder.outboundRemarks"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "section" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("Warehouse.CargoDetails")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-row grid-list" },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                "label-width": "100px",
                                "label-position": "left",
                                disabled: true
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("cargo-ag-grid", {
                                    ref: "goodsTable",
                                    staticStyle: { height: "200px" },
                                    attrs: {
                                      "grid-options":
                                        _vm.detailList.goodGridOptions,
                                      "column-defs": _vm.goodsColumn,
                                      "row-data": _vm.detailDatas || []
                                    },
                                    on: {
                                      gridReady: function(params) {
                                        _vm.detailList.gridApi = params.api
                                      }
                                    }
                                  }),
                                  _c(
                                    "el-form-item",
                                    { staticClass: "auto-width" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "title-row",
                                          staticStyle: {
                                            display: "flex",
                                            "text-align": "left"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "font-weight": "normal",
                                                color: "#404144",
                                                "white-space": "nowrap",
                                                width: "130px",
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_NetGrossWeight"
                                                  )
                                                ) +
                                                  _vm._s(
                                                    _vm.openImperial
                                                      ? "(LB)"
                                                      : "(KG)"
                                                  )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "font-weight": "normal",
                                                color: "#404144",
                                                "white-space": "nowrap",
                                                width: "130px",
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_GrossWeight2"
                                                  ) +
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Weight"
                                                    )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "font-weight": "normal",
                                                color: "#404144",
                                                "white-space": "nowrap",
                                                width: "130px",
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.ChargedWeight"
                                                  )
                                                ) +
                                                  _vm._s(
                                                    _vm.openImperial
                                                      ? "(LB)"
                                                      : "(KG)"
                                                  )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "font-weight": "normal",
                                                color: "#404144",
                                                "white-space": "nowrap",
                                                width: "130px",
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Quantity")
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "font-weight": "normal",
                                                color: "#404144",
                                                "white-space": "nowrap",
                                                width: "130px",
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("SeaExport.Cubage")
                                                ) +
                                                  _vm._s(
                                                    _vm.openImperial
                                                      ? "(CFT)"
                                                      : "(CBM)"
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "auto-width",
                                      attrs: { label: " " }
                                    },
                                    [
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.openImperial,
                                            expression: "!openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "weightSum",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value: _vm.pickingOrder.weightSum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "weightSum",
                                              $$v
                                            )
                                          },
                                          expression: "pickingOrder.weightSum"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openImperial,
                                            expression: "openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "weightSumImperial",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder.weightSumImperial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "weightSumImperial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.weightSumImperial"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.openImperial,
                                            expression: "!openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "grossWeightSum",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder.grossWeightSum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "grossWeightSum",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.grossWeightSum"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openImperial,
                                            expression: "openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "grossWeightSumImperial",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder
                                              .grossWeightSumImperial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "grossWeightSumImperial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.grossWeightSumImperial"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.openImperial,
                                            expression: "!openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "chargedWeight",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder.chargedWeightSum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "chargedWeightSum",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.chargedWeightSum"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openImperial,
                                            expression: "openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "chargedWeightSumImperial",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 2,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder
                                              .chargedWeightSumImperial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "chargedWeightSumImperial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.chargedWeightSumImperial"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        attrs: {
                                          no: "quantitySum",
                                          disabled: true,
                                          "controls-position": "right",
                                          min: 0,
                                          max: 999999999,
                                          precision: 0
                                        },
                                        model: {
                                          value: _vm.pickingOrder.quantitySum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "quantitySum",
                                              $$v
                                            )
                                          },
                                          expression: "pickingOrder.quantitySum"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.openImperial,
                                            expression: "!openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "cubageSum",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 3,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value: _vm.pickingOrder.cubageSum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "cubageSum",
                                              $$v
                                            )
                                          },
                                          expression: "pickingOrder.cubageSum"
                                        }
                                      }),
                                      _c("el-input-number", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openImperial,
                                            expression: "openImperial"
                                          }
                                        ],
                                        attrs: {
                                          no: "cubAgeSumImperial",
                                          disabled: true,
                                          "controls-position": "right",
                                          precision: 3,
                                          min: 0,
                                          max: 999999999
                                        },
                                        model: {
                                          value:
                                            _vm.pickingOrder.cubAgeSumImperial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pickingOrder,
                                              "cubAgeSumImperial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pickingOrder.cubAgeSumImperial"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "section" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("Warehouse.CargoPhotos")))
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-row grid-list" },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                "label-width": "100px",
                                "label-position": "left",
                                disabled: true
                              }
                            },
                            [
                              _c(
                                "el-form",
                                { staticClass: "spacing" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-right": "5px"
                                      },
                                      attrs: {
                                        action:
                                          _vm.URL.warehouseIn
                                            .uploadFileForPickingOrder +
                                          "?saveFile=true&pickingOrderKey=" +
                                          _vm.pickingOrder.uuid,
                                        headers: {
                                          sessionId: _vm.$store.getters.token
                                        },
                                        "show-file-list": false,
                                        "on-success": _vm.uploadSuccess,
                                        "on-change": _vm.toChooseFile
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { no: "42", type: "primary" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Warehouse.SelectFile")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", no: "43" },
                                      on: { click: _vm.delPhotoHandler }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Warehouse.DeleteFile"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("cargo-ag-grid", {
                                ref: "photosList",
                                attrs: {
                                  "grid-options": _vm.photoList.gridOptions,
                                  "column-defs": _vm.photoList.photoColumn,
                                  "row-data": _vm.documentDatas
                                },
                                on: {
                                  gridReady: function(params) {
                                    _vm.photoList.gridApi = params.api
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }